export default __webpack_public_path__ + "static/media/incompatible_photo.f83aed90.svg";